import React from 'react';
import { RegisterItemList } from './RegisterItemList';

export const ThreatList: React.FC = () => {
  return (
    <RegisterItemList
      title="Threats"
      iconClass="ri-skull-2-line"
      listPath="/threats"
      detailPathPrefix="/threats"
      configPath="/threat-config"
      registersPath="/threat-registers"
      idField="threatId"
      titleField="threat_name"
      priorityField="threat_priority"
      statusField="threat_status"
      registerQueryParam="registerId"
    />
  );
};
